import React from "react";
import classes from "./Checkbox.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const Checkbox = ({ value = false, onClick = null, children = null }) => {
  let finalClass = classes.Checkbox;
  if (value === true) finalClass += " " + classes.Active;

  const keyPresed = (event) => {
    if (onClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onClick();
    }
  };
  return (
    <div className={classes.CheckboxArea}>
      <div
        tabIndex="0"
        className={finalClass}
        onKeyDown={(event) => keyPresed(event)}
        value={value}
        onClick={onClick}
      >
        {value === true && (
          <FontAwesomeIcon className={classes.Icon} icon={faCheck} />
        )}
      </div>
      {children && <div className={classes.Children}>{children}</div>}
    </div>
  );
};

export default Checkbox;
